import BigNumber from 'bignumber.js';

export const multiply = (...numbers: number[]): number => {
  return numbers
    .reduce((total, current) => total.multipliedBy(current), new BigNumber(1))
    .toNumber();
};

export const multiplyByPercent = (number1: number, number2: number): number => {
  return multiply(number1, number2, 0.01);
};

export const divide = (number1: number, number2: number): number => {
  return new BigNumber(number1).dividedBy(number2).toNumber();
};

export const sum = (...numbers: number[]): number => {
  return numbers.reduce((total, current) => total.plus(current), new BigNumber(0)).toNumber();
};
